import script from "./field.vue?vue&type=script&setup=true&lang=ts"
export * from "./field.vue?vue&type=script&setup=true&lang=ts"

import "./field.vue?vue&type=style&index=0&id=06566f99&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06566f99"]])

export default __exports__